<template>
    <div id="enterprise_detail">
        <leftnav class="fl"></leftnav>
        <div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
            <govheader></govheader>
            <div class="index_left_centerpage">
                <div class="enterprise_detail">
                    <div class="whitebox centerpage">
                        <div class="d_blocktitle">
                            <i class="title-icon title-icon1"></i>
                            <h3 class="ctitle">{{ companyinfor.company.company }}</h3>
                        </div>
                        <ul class="oh conpany-infor-new">
                            <li class="inforLine inforLine-3"><span class="label">企业地址：</span><span
                                    class="infortext">{{ companyinfor.company.province }}-{{ companyinfor.company.city }}</span> </li>
                            <li class="inforLine inforLine-3"><span class="label">联系电话：</span><span
                                    class="infortext">{{ turnPhone(companyinfor.company.phone)}}</span> </li>
                            <li class="inforLine inforLine-one" v-if="companyinfor.company.summary && companyinfor.company.summary.length > 0"><span
									class="label">企业简介：</span><span class="infortext">{{ companyinfor.company.summary }}</span>
							</li>
                            <li class="inforLine inforLine-3 com_website">
								<span class="label">网 址：</span>
								<span v-if="companyinfor.company.website && companyinfor.company.website.length > 3" @click="rwebsite = true"
									class="curp infortext">{{ enterpriseWebsite }}</span>
								<span class="infortext"
									v-if="companyinfor.company.website && companyinfor.company.website.length < 4">{{ companyinfor.company.website }}</span>
							</li>
                        </ul>

                    </div>
                    <div class="whitebox company-contact">
                        <div class=" d_blocktitle d-floortitle">
                            <i class="title-icon title-icon2"></i>
                            <h3 class="title">联系方式</h3>
                        </div>
                        <ul class="oh conpany-infor-new">
                            <li class="inforLine inforLine-3"><span class="label">乡贤姓名：</span><span
                                    class="infortext">{{ companyinfor.person.name }}</span> </li>
                            <li class="inforLine inforLine-3"><span class="label">联系电话：</span><span class="infortext">{{companyinfor.person.phone}}</span> </li>
                            <li class="inforLine inforLine-3"><span class="label">性别：</span><span
                                    class="infortext">{{ companyinfor.person.gender || '-' }}</span> </li>
                            <li class="inforLine inforLine-3"><span class="label">担任职位：</span><span
                                    class="infortext">{{ companyinfor.person.position || '-' }}</span> </li>
                            <li class="inforLine inforLine-one"><span class="label">籍贯：</span><span
                                    class="infortext">{{ companyinfor.person.province }}-{{ companyinfor.person.city }}-{{ companyinfor.person.county }}</span>
                            </li>
                            <li class="inforLine inforLine-one" v-if="companyinfor.person.summary && companyinfor.person.summary.length > 0"><span
									class="label">简介：</span><span class="infortext">{{ companyinfor.person.summary }}</span>
							</li>
                            
                        </ul>
                        <div class="enprise_websitebox" v-show="rwebsite" @click="rwebsite = false">
                            <div class="enprise_website">
                                <h2>您即将跳转进入第三方网站</h2>
                                <p class="website_tips"><b>产业大脑</b>不对该网站内容及真实性负责，请注意您的账户和财产安全</p>
                                <p class="website_text"><a :href="enterpriseWebsite"
                                        target="_blank">{{ enterpriseWebsite }}</a></p>
                                <a class="router_website" :href="enterpriseWebsite" target="_blank">继续前往</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
    name: 'institutionDetail',
    computed: {
        ...mapState({
            isCollapse: (state) => state.isCollapse,
        }),
        ...mapGetters(['isCollapse'])
    },
    data() {
        return {
            curindex: 5,
            searchtype: 6, enterpriseWebsite: "",
            guidepage: '广东企业', echartWidth2: document.body.offsetWidth * 0.8728 * 0.95 * 0.48,
            userdata: {}, othertransList: [], conditionBar1Data: { value: [0, 0, 0, 0], noEmpty1: false }, conditionBar2Data: { value: [0, 0, 0, 0], noEmpty1: false, },
            id: 0, profitData: { date: [], list: [], unit: "" }, debtData: { date: [], list: [], unit: "" }, cashData: { date: [], list: [], unit: "" },
            companyinfor: { company: {}, person: {} },
            floorlist: ['联系方式', '投资领域', '投资事件'],
            rwebsite: false, barHeight: 60,enterpriseWebsite:"",rwebsite:false
        }
    },
    beforeCreate() {

    },
    created() {
        this.$nextTick(() => {
            // 禁用右键
            document.oncontextmenu = new Function("event.returnValue=false");
            // 禁用选择
            document.onselectstart = new Function("event.returnValue=false");
        });
        // window.scrollTo(0,0);
        this.bus.$emit('loading', true);
        this.id = this.$route.query.id;
        var _this = this;
        this.userdata = this.getuseriformation();

    },
    mounted() {
        window.scrollTo(0, 0);
        this.getDetails();

    },
    methods: {
        //隐藏手机号
			turnPhone(val) {
				if (!val) return '-';
				return val.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2');
				
			},
        //判断企业网址是否符合标准 长度大于4并且要有http
		getEnterpriseWebsite(str) {
			// console.log('str',str)
			if (str.length > 3) {
				if (str.indexOf('http') < 0) {
					str = 'http://' + str;
				}
			}
			this.enterpriseWebsite = str;
		},
        getDetails() {
            var _this = this;
            let ajaxurl = this.$api.cyl.investclue.localworthyDetail() + '?uuid=' + this.id;
            this.$axios.get(ajaxurl, {
                headers: {
                    AuthToken: this.userdata.token
                },
            }).then((res) => {
                if (res.data.success) {
                    console.log(res);
                    this.companyinfor = res.data.data;
                    document.title = this.companyinfor.person.name;

                }
            })
        },
        //判断企业网址是否符合标准 长度大于4并且要有http
        getEnterpriseWebsite(str) {
            // console.log('str',str)
            if (str.length > 3) {
                if (str.indexOf('http') < 0) {
                    str = 'http://' + str;
                }
            }
            this.enterpriseWebsite = str;
        },
        //添加删除收藏
        collectFun() {
            // console.log(this.companyinfor.collectId,this.companyinfor);
            this.listToggleCollect(this.companyinfor, 'org');
        },

        //企业网址跳转
        geturl(url) {
            if (url.indexOf('http') < 0) {
                url = 'http://' + url;
            }
            window.open(url);
        },
    }
}
</script>

<style scoped>
.conpany-infor-new .infortext {
    float: left;
    width: calc(100% - 160px);
}

.conpany-infor-new .label {
    color: #999;
    margin-right: 4px;
    width: 151px;
    float: left;
}

.enterprise_table {
    margin-bottom: 50px;
}

.endsm_title {
    border-left: 8px solid #3e7bfa;
    line-height: 20px;
    padding-left: 14px;
    margin: 10px 0 30px;
}
</style>
